import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  performAction(ev) {
    ev.preventDefault()
    ev.stopPropagation()
    const {controller, action} = ev.params
    const element = this.element.querySelector(`[data-controller="${controller}"]`)
    if(!element) {
      console.error(`element for controller ${controller} not found`)
      return
    }
    const ctrl = this.application.getControllerForElementAndIdentifier(element, controller)
    if(!ctrl) {
      console.error(`controller ${controller} not found`)
      return
    }
    ctrl[action]?.(ctrl)
  }
}